import * as React from 'react';
import { CategoryNamesAndIds } from '../../constants/constant';
import { H1 } from '@liveauctioneers/hammer-ui-core/text';
import { InlineButton } from '@liveauctioneers/hammer-ui-core/inlineButton';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import FormattedMessage from '@/components/Formatted/FormattedMessageText';
import styled from 'styled-components';

type Props = {
    isMobile: boolean;
    scrollToCategory: (categoryId: number) => void;
};

const SideBar = ({ isMobile, scrollToCategory }: Props) => {
    const { formatMessage } = useIntl();
    const CATEGORIES = Object.keys(CategoryNamesAndIds);

    if (isMobile) {
        return null;
    }

    return (
        <StyledSideBarDiv>
            <StyledHeader data-testid="discoverPageTitle">
                <FormattedMessage id="discoverPage.exploreCategories" />
            </StyledHeader>
            {CATEGORIES.map((category, index) => (
                <SideBarItem
                    key={index}
                    onClick={() => scrollToCategory(index)}
                    style="neutral"
                >
                    {formatMessage({ id: 'discoverPage.sidebar.category' }, { category })}
                </SideBarItem>
            ))}
            <SideBarItem
                onClick={() => {
                    scrollToCategory(CATEGORIES.length);
                }}
                style="neutral"
            >
                {formatMessage({
                    id: 'discoverPage.sidebar.allOtherCategories',
                })}
            </SideBarItem>
        </StyledSideBarDiv>
    );
};

export default SideBar;

const StyledHeader = styled(H1)`
    margin: 32px 0;
    width: max-content;
    position: sticky;
    top: 0;
    background: ${({ theme }) => theme.colors.white};
`;

const StyledSideBarDiv = styled.div`
    align-self: flex-start;
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: column;
    width: fit-content;
`;

const SideBarItem = styled(InlineButton)`
    margin-bottom: 22px;
    width: max-content;
`;
